// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".doc-list[data-v-cc480d72]{display:block;display:flex;flex-direction:column}@media screen and (max-width:750px){.doc-list[data-v-cc480d72]{background:#fff;margin:0 -16px -32px;padding:24px 16px}}.doc-list__title[data-v-cc480d72]{margin-bottom:32px}.doc-list a+a[data-v-cc480d72]{margin-top:16px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
